import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';
import { Meta } from '@angular/platform-browser';
import { ExclusionsListService } from 'src/app/services/exclusions-list.service';
import { ExclusionList } from 'src/app/models/exclusion-list';
import { SafePipe } from 'src/app/pipes/safe.pipe';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-strategy',
    templateUrl: './strategy.component.html',
    styleUrls: ['./strategy.component.scss'],
    providers: [ExclusionsListService],
    imports: [SafePipe,CommonModule]
})
export class StrategyComponent implements OnInit {

  title = "Catholic Values Investing Portfolios excluded companies list.";

  exclusions: ExclusionList[]

  constructor(
    private seoservice: SeoService, 
    private meta: Meta, 
    private exlusionservice: ExclusionsListService, 
    private cdr: ChangeDetectorRef
  ) { 

    this.exlusionservice.getExclusionsList().subscribe(resp => {
   
      //removes first article from header
      this.exclusions = resp;
      this.cdr.detectChanges();
   
    })
// $&(this.exclusions)

  }

  ngOnInit() {

    this.seoservice.updateTitle(this.title);
  	this.meta.addTag({name: 'keywords', content: 'catholic values investing, excluding companies list, socially responsible investing'});
    this.meta.addTag({name: 'description', content: 'Investing for Catholics Catholic Values Investing Portfolios excluded companies list.'});
    this.meta.addTag({name: 'author', content: 'Investing for Catholics (IFC)'});
    this.meta.addTag({name: 'robots', content: 'index, follow'});

  }

}
